import Breadcrumbs from "../../../common/breadcrumb/Breadcrumbs"
import AddMainModule from "../../../components/RolePermission/addMainModule/AddMainModule"


function AddMainModulePage() {
    return (
        <>
        <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Role & Permission",
    title_2: "Main Module List",
  }} />
            <AddMainModule />
        </>
    )
}
export default AddMainModulePage